exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img[data-v-21d5787b]{cursor:pointer;display:block;width:50px;height:50px;margin-right:4px;margin-bottom:4px}.flex_box[data-v-21d5787b]{width:100%;padding:0 10px;display:-webkit-box;display:-ms-flexbox;display:flex}.flex_box .tips span[data-v-21d5787b]{margin-right:4px}.img-box[data-v-21d5787b]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}\n", ""]);

// exports
